import React from 'react'

import SEO from '@components/seo'
import HomeHeroField from '@components/home-hero-field'
import ContactPageForm from '@components/contact-page-form'
import IndexLayout from '../../layouts'

/* /contact/message/ — the dedicated contact form, built on the /demo/ funnel's
   design rather than a lookalike of it.

   IT CARRIES `demo demo-dark`, WHICH IS A SEPARATE SYSTEM FROM `.frontpage`. The
   demo funnel has its own gradient, spotlight animation and white form card; none
   of that is in the marketing design system. Opting into `.frontpage` here would
   have meant rebuilding the card and the field skin from scratch.

   FULL SITE CHROME, NOT THE MINIMAL FUNNEL SHELL. This started on `DemoLayout`,
   which is `MenuMinimal` — logo and Sign In only, no nav, no footer. That is right
   for `/demo/` and `/demo/calendar/`, which sit INSIDE a funnel someone has already
   committed to. This page is a destination people arrive at cold from `/contact/`,
   from search or from a link, and stripping the nav and footer left them with no
   way onward and no address, privacy policy or social links.

   `--with-chrome` IS WHAT MAKES THAT WORK, and it is not just a class name: it
   swaps `min-height: 100vh` for `min-height: 0`, so the page stops reserving a
   screen's worth of empty dark below a short form, and it ends the background
   gradient on #0c0b26 — the footer's exact colour — so the two meet with no seam.
   Any other end value shows a line. `/demo/confirm/` uses the same combination.

   `speed={0.06}` and `packets={false}` on the constellation are the demo funnel's
   values, not the marketing default of 1. The bright drifting packets were the
   distracting part behind a form, and this page has the same problem.

   NO TESTIMONIAL. /demo/ closes with the Walmart quote; this page carried it too
   and it has been removed at Colin's request. That also removed the page's only
   `useStaticQuery` — there are no images left to query, which is why there is no
   GraphQL in this file at all any more. If a quote comes back, it needs the
   `personImage` / `walmartLogo` query from `src/pages/demo/index.tsx` back with it.

   ROUTE: this lives at `/contact/message/` alongside `src/pages/contact.tsx` at
   `/contact/`. Gatsby's page creator handles a file and a same-named directory
   without conflict, so the parent page is untouched. */

const ContactMessagePage = () => {
  return (
    <IndexLayout bodyWrapperClass="demo demo-dark demo-dark--with-chrome demo-dark--contact">
      <div className="demo-dark__field" aria-hidden="true">
        <HomeHeroField tint="multi" wide speed={0.06} packets={false} />
      </div>
      <div className="demo-dark__spotlight" aria-hidden="true" />

      <div className="demo-dark__inner">
        <div className="container">
          {/* DRAFT COPY — NOT YET APPROVED. Flag on handback.

              The heading answers "will a human read this?", which is the only real
              question someone has before typing into a contact form. It deliberately
              does not promise a response time — that is an operational commitment
              nobody has signed off. */}
          <header className="demo-dark__head">
            <h1 className="demo-dark__heading">
              Send us a{' '}
              <span className="demo-dark__heading-accent">message</span>
            </h1>
            <p className="demo-dark__text">
              Partnerships, research collaborations, press, procurement or
              anything else that needs a conversation. Tell us what you need and
              we’ll route it to the right person.
            </p>
          </header>

          <div className="demo-dark__stack">
            <div className="demo-dark__form-card">
              <ContactPageForm />
            </div>
          </div>
        </div>
      </div>
    </IndexLayout>
  )
}

export function Head({ location }: { location: { pathname: string } }) {
  return (
    <SEO
      title="Send Cognitive3D a Message | Contact the Team"
      description="Message the Cognitive3D team about partnerships, research collaborations, press, procurement or general enquiries about XR analytics."
      pathname={location.pathname}
    />
  )
}

export default ContactMessagePage
